import React, {useEffect,useState, Fragment} from 'react';
import Swal from 'sweetalert2';
import ClienteAxios from './config/axios';
import Header from './componentes/Header'
import Formulario from './componentes/Formulario'
import Fincamadre from './componentes/Fincamadre'



function App() {
  const RUTA_API = `${process.env.REACT_APP_RUTA_API}`
  const [fincasMadres, guardarfincas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const obtenerFincas = async (datosCriterio) => {
    guardarfincas([]);
    setIsLoading(true);
		try {
        //const { fincamadre,ubicacion } = datosCriterio;   
        //let fincasm = fincamadre.toString()
        //let ubicacionm = ubicacion.length > 0 ? ubicacion : '-'
        // console.log(datosCriterio); 
        // console.log(RUTA_API); 
        //const res = await ClienteAxios(`/rpmovil/public/webresources/mobile_app/BuscarFincaMadre3/${fincasm}/${ubicacionm}`);
        const res = await ClienteAxios.post(RUTA_API,datosCriterio);
        //console.log(res.data.data);
        const datos = await res.data.data;
       // console.log(resultado);
        await guardarfincas(datos);
        setIsLoading(false);
            
		  } catch (error){
        //console.log(error)
        setIsLoading(false);
        Swal.fire({
          icon: 'warning',
          title: 'No hay resultado',
          text: 'No existen registros para el criterio selecionado'
      })
		  }
    }   

    // cuando el componente carga
    useEffect(() => {
     
    }, [])

   
    let resultado;

    if(isLoading){
      resultado = <div className="spinner">
                    <div className="rect1"></div>
                    <div className="rect2"></div>
                    <div className="rect3"></div>
                    <div className="rect4"></div>
                    <div className="rect5"></div>
                  </div>
    } else{
      resultado =   <Fincamadre
                        fincasMadres={fincasMadres}
                    />
    } 

  return (
      <Fragment>
      <div className="App">
        <Header/>
        <div className="container-fluid">
          <Formulario
            obtenerFincas={obtenerFincas}
          />
            <Fragment>
            <div className="row">
              <div className="col-12">
                 {resultado}
              </div>
            </div>
            </Fragment>
        </div>
      </div>
    </Fragment>
  );
}

export default App;
